import { __awaiter } from "tslib";
import { AbortController } from 'src/global/abort-controller/AbortController';
export function combineAbortSignals(...abortSignals) {
    const abortController = new AbortController();
    function onAbort() {
        abortController.abort();
    }
    for (let i = 0; i < abortSignals.length; i++) {
        const abortSignal = abortSignals[i];
        if (!abortSignal) {
            continue;
        }
        if (abortSignal.aborted) {
            onAbort();
            break;
        }
        else {
            abortSignal.addEventListener('abort', onAbort);
        }
    }
    return abortController.signal;
}
export function useAbortController(func) {
    return __awaiter(this, void 0, void 0, function* () {
        const abortController = new AbortController();
        try {
            return yield func(abortController.signal);
        }
        finally {
            abortController.abort();
        }
    });
}
